import { render } from "./jjcg.vue?vue&type=template&id=e9117dc8&scoped=true&ts=true"
import script from "./jjcg.vue?vue&type=script&lang=ts"
export * from "./jjcg.vue?vue&type=script&lang=ts"

import "./jjcg.vue?vue&type=style&index=0&id=e9117dc8&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9117dc8"]])

export default __exports__